<template>
  <div class='base-line'>
    <a-row class="row">
      <a-col :span="12" class="title">
        基线
      </a-col>
      <a-col :span="12" style="text-align: right">
        <a-button class='button' type='primary' @click='handleEdit'>配置</a-button>
      </a-col>
    </a-row>
    <a-descriptions :column="2">
      <a-descriptions-item label="基线名称">
        {{baseLine.name}}
      </a-descriptions-item>
      <a-descriptions-item label="关联事件">
        {{baseLine.visitName}}
      </a-descriptions-item>
      <a-descriptions-item label="距基点天数">
        {{baseLine.basePointDay}}
      </a-descriptions-item>
      <a-descriptions-item label="最大可提前天数">
        {{baseLine.advanceDay}}
      </a-descriptions-item>
      <a-descriptions-item label="最大可延后天数">
        {{baseLine.delayDay}}
      </a-descriptions-item>
      <a-descriptions-item label="允许未到期作答">
        <yn v-model="baseLine.answerUnexpired"></yn>
      </a-descriptions-item>
      <a-descriptions-item label="允许过期作答">
        <yn v-model="baseLine.answerOverdue"></yn>
      </a-descriptions-item>
    </a-descriptions>
    <CsimVisitBaseLineModel 
      ref='CsimVisitBaseLineModel' 
      @ok="handleOk"
      :projectVisitList="projectVisitList"
    ></CsimVisitBaseLineModel>
  </div>
</template>
<!--基线配置-->
<script>
  import { getAction } from '@/api/manage'
  import CsimVisitBaseLineModel from './CsimVisitBaseLineModel'
  import { CACHE_PROJECT_ID } from '@/constants/project'
  import Vue from 'vue'
  import Yn from '@/views/project/setting/visit/component/Yn'

  export default {
    name: 'CsimVisitBaseLine',
    components: { 
      Yn, 
      CsimVisitBaseLineModel 
    },
    props: {
      projectVisitList: {
        type: Array,
        required: false
      },
    },
    data(){
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        baseLine:{},
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        getAction('/project/projectPeriodItem/baseLine',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.baseLine = res.result[0]
          }
        })
      },
      handleEdit(){
        if(!this.baseLine.id){
          return this.$message.warning('请求异常，请稍等或者刷新页面再试')
        }
        this.$refs["CsimVisitBaseLineModel"].edit(this.baseLine)
      },
      handleOk(){
        this.loadData()
      }
    },
  }
</script>

<style scoped>
  .row{
    margin-bottom: 10px;
  }
</style>